import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { NavService } from '../../_services/_nav.service';
import { ExcepcionGmfService } from '../../_services/excepcion-gmf.service';
import { ExcepcionGMF } from '../../_models/excepcion-gmf';
import { ExcepcionGMFFormaDesembolso } from '../../_models/excepcion-gmf-forma-desembolso';
import { ExcepcionGMFDestinoService } from '../../_services/excepcion-gmf-destino.service';
import { ExcepcionGMFDestino} from '../../_models/excepcion-gmf-destino';
import { ExcepcionGMFTipoCreditoService } from '../../_services/excepcion-gmf-tipo-credito.service';
import { ExcepcionGMFFormaDesembolsoService } from '../../_services/excepcion-gmf-forma-desembolso.service';
import { ExcepcionGMFTipoCredito } from '../../_models/excepcion-gmf-tipo-credito';

@Component( {
  selector: 'app-excepciones-gmf-detalle',
  templateUrl: 'excepciones-gmf-detalle.component.html'
} )

export class ExcepcionesGmfDetalleComponent implements OnInit {

  excepcionGMF: ExcepcionGMF;
  excepcionGMFFormaDesembolso: ExcepcionGMFFormaDesembolso;
  excepcionGMFTipoCredito: ExcepcionGMFTipoCredito;
  excepcionesGMFDestinos: ExcepcionGMFDestino [] = [];
  carInformacionInicial = true;
  columnas: any[];

  constructor( private excepcionGMFServicio: ExcepcionGmfService,
               private excepcionGMFDestinoService: ExcepcionGMFDestinoService,
               private excepcionGMFTipoCreditoServicio: ExcepcionGMFTipoCreditoService,
               private excepcionGMFFormaDesembolsoServicio: ExcepcionGMFFormaDesembolsoService,
               private route: ActivatedRoute,
               private nav: NavService,
               private location: Location ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'destino', header: this.nav.buscarMensaje( 'EXCEPCIONESGMF.LBL_DESTINO' ), sort: false },
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.excepcionGMFServicio.obtenerPorId( params[ 'id' ] ),
        this.excepcionGMFDestinoService.obtenerPorIdExcepcionGMF( params[ 'id' ] ),
        this.excepcionGMFTipoCreditoServicio.obtenerPorIdExcepcionGMFHabilitado( params[ 'id' ] ),
        this.excepcionGMFFormaDesembolsoServicio.obtenerPorIdExcepcionGMFHabilitado( params[ 'id' ] ),
      ).subscribe( ( [ excep, excepDestino, excepGMFTipoCredito, excepcionGMFFormaDes ] ) => {
        this.excepcionGMF = excep;
        this.excepcionesGMFDestinos = excepDestino;
        this.excepcionGMFTipoCredito = excepGMFTipoCredito;
        this.excepcionGMFFormaDesembolso = excepcionGMFFormaDes;
        this.excepcionesGMFDestinos = this.excepcionesGMFDestinos.filter( x => x.indicadorHabilitado === true );
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
